import React from "react";

import Context from "../../../context/Context";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Topic from "../../../context/Topic";
import TransactionGuard from "../../base/TransactionGuard";
import * as component from "../../../components/util/component";

import { Formik, Field, ErrorMessage } from "formik";

import Checkbox from "calcite-react/Checkbox";
import Form, { FormControl, FormControlLabel } from "calcite-react/Form";
import TextField from "calcite-react/TextField";
import FieldNames from "../../../aiim/datasets/FieldNames";
import * as aiimUtil from "../../../aiim/util/aiimUtil";

export default class AddArea extends React.Component {
  componentId;

  constructor(props) {
    super(props);
    this.componentId = component.nextId();
    this.state = component.newState({
      name: "",
      restricted: true
    });
    this.onChangeName = this.onChangeName.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  static isInvalidPattern(name){
    var charPattern=/<[a-zA-Z0-9` !@#$%^&*()_+\-=\[\]{};':"\\|,.\/?~]*>/g;
    return name.match(charPattern);
  }

  onChangeName(evt) {
    const v = evt.target.value;
    this.setState({name: v});
    if (this.props.onChange) {
      this.props.onChange({
        name: v,
        restricted: this.state.restricted
      });
    }
  }

  onChangeRestricted = evt => {
    let v = !!evt.target.checked;
    this.setState({restricted: v});
    if (this.props.onChange) {
      this.props.onChange({
        name: this.state.name,
        restricted: v
      });
    }
  }

  onValidate = values => {
    const errors = {};
    const i18n = Context.instance.i18n;
    const emptyInput = i18n.spaceplanner.areaProperties.emptyAreaName;
    const invalidInput = i18n.spaceplanner.areaProperties.invalidAreaName;

    if (!values.name || values.name.trim().length === 0) {
      errors.name = emptyInput;
    }

    const patternMatch = AddArea.isInvalidPattern(values.name);
    if(patternMatch){
      errors.name = invalidInput;
    }

    return errors;
  };

  render() {
    const i18n = Context.instance.i18n;
    const id = this.componentId;
    const horizontal = false;
    const cls = horizontal ? "i--form i--form-horizontal" : "i--form";
    const supportsRestricted = !!this.props.supportsRestricted;

    // Formik value object
    const form = {
      name: this.state.name,
      restricted: this.state.restricted
    };

    return (
      <Formik
        initialValues={form}
        validate={this.onValidate}
        onSubmit={this.props.submitHandle}
      >
        {({ values, errors, touched, handleSubmit, isSubmitting }) => (
          <Form className={cls} onSubmit={handleSubmit}>
            <FormControl horizontal={horizontal}>
              <FormControlLabel
                id={id + "-name-label"}
                htmlFor="name"
                className="i--form-label"
              >
                <span className="i--required">
                  {i18n.spaceplanner.areaProperties.name}
                </span>
              </FormControlLabel>

              <Field
                component={TextField}
                id={id + "-name"}
                name="name"
                fullWidth={true}
                autoFocus
                onChange={this.onChangeName}
              />
              <ErrorMessage
                name="name"
              />
            </FormControl>
            {supportsRestricted &&
              <FormControl horizontal={true}>
                <Field
                  component={Checkbox}
                  id={id + "-restricted"}
                  name="restricted"
                  onChange={this.onChangeRestricted}
                />
                <FormControlLabel
                  id={id + "-restricted-label"}
                  htmlFor="restricted"
                  className="i--form-label"
                >
                  <span>
                    {i18n.spaceplanner.areaProperties.restricted}
                  </span>
                </FormControlLabel>
              </FormControl>
            }
          </Form>
        )}
      </Formik>
    );
  }

  static showModal(props) {
    let controller,
    areaName = "",
    patternMatch = "",
    restricted = false,
    adding = false;
    const i18n = Context.instance.i18n;
    const plan = Context.instance.spaceplanner.activePlan;
    const areasTable = plan && plan.areasTable;
    const areaType = props.areaType;
    const officePlan = OfficePlan.getActive();
    const supportsRestricted = !!officePlan.areasTable.getRestrictedField();

    const confirmModal =(options)=>{
      if(controller) controller.close();
      ModalController.confirm(options).then(result => {
        if(result.ok){
          onOK();
        }
      })
    }

    const doesHotdeskAreaExist=()=>{
      let isDuplicate= false;
      officePlan.queryHotDeskAreas().then(areas => {
        const result=areas;
        for(let i=0;i<result.length;i++){
          const name=aiimUtil.getAttributeValue(result[i].attributes,FieldNames.AREA_NAME);
          if(name === areaName){
            isDuplicate=true;
            const options = {
              title: i18n.spaceplanner.areaProperties.createDuplicateHotdeskName,
              message: i18n.spaceplanner.areaProperties.createDuplicateHotdeskNamePrompt,
              okLabel: i18n.general.ok,
              closeOnOK: true,
              closeOnCancel: true
            };
            confirmModal(options);
            break;
          }
        }
      }).then(()=>{
        if(isDuplicate === false){
          onOK();
        }
      })
      .catch(ex => {
        console.warn("Error querying hotel areas:");
        console.error(ex);
        Topic.publishErrorAccessingData();
      });
    }

    const doesHotelNameExist=()=>{
      let isDuplicate= false;
      officePlan.queryHotelAreas().then(areas => {
        const result=areas;
        for(let i=0;i<result.length;i++){
          const name=aiimUtil.getAttributeValue(result[i].attributes,FieldNames.AREA_NAME);
          if(name === areaName)
          {
            isDuplicate=true;
            const options = {
              title: i18n.spaceplanner.areaProperties.createDuplicateHotelName,
              message: i18n.spaceplanner.areaProperties.duplicateHotelNamePrompt,
              okLabel: i18n.general.ok,
              closeOnOK: true,
              closeOnCancel: true
            };
            confirmModal(options);
            break;
          }
        }
      }).then(()=>{
        if(isDuplicate === false){
          onOK();
        }
      })
      .catch(ex => {
        console.warn("Error querying hot desk areas:");
        console.error(ex);
        Topic.publishErrorAccessingData();
      });
    }

    const doesAreaNameExist =()=>{
      if(areaType === "hotel"){
        doesHotelNameExist();
      }
      if(areaType === "hotdesk"){
        doesHotdeskAreaExist();
      }
    }

    const onChange = obj => {
      areaName = obj.name.trim();
      patternMatch = AddArea.isInvalidPattern(areaName);
      restricted = !!obj.restricted;
    };

    const onOK = obj => {
      if (!adding && areaName.length > 0 && !patternMatch) {
        if(controller) controller.close();
        const guard = new TransactionGuard({force: true});
        adding = true;
        areasTable
          .addArea(areaName,areaType,restricted)
          .then(result => {
            guard.close();
            Topic.publish(Topic.PlanModified, {
              action: OfficePlan.Action_AssignmentsUpdated
            });
            //if(controller) controller.close();
          })
          .catch(error => {
            guard.close();
            console.error("Error adding area", error);
            //if(controller) controller.close();
            Topic.publishErrorUpdatingData(error.submessage);
          });
      }
    };

    const modalProps = {
      dialogStyle: { width: "35vw" },
      title: props.caption,
      showOKCancel: true,
      closeOnOK: false,
      onOK: doesAreaNameExist,
      okLabel: i18n.spaceplanner.areaProperties.add
    };

    if (plan && plan.wasOpened && plan.isAreasTableValid() && areasTable) {
      const content = (
        <AddArea {...props}
          onChange={onChange}
          submitHandle={doesAreaNameExist}
          supportsRestricted={supportsRestricted}/>
      );
      controller = new ModalController({});
      controller.show(modalProps, content);
    }
  }
}
